<template>
  <div class="navbar navbar-expand-lg navbar-light bg-light ecd-navbar" style="height:60px;">
    <div class="col-6 col-sm-10">
      <select v-model="store.state.serviceSlug" style="width:200px" class="form-control">
        <option value=""></option>
        <option :value="service.slug" v-for="service in store.state.services" :key="service.id">{{service.name}}</option>
      </select>
    </div>
    <div class="col-6 col-sm-2">
      <router-link to="/account/listing/create" style="float:right">
          <button class="btn btn-primary btn-orange">Create a Listing</button>
      </router-link>
      </div>
  </div>
</template>

<script>
import BreadcrumbStore from './BreadcrumbStore'
import Navigator from '@/router/navigator'
export default {
  name: "Breadcrumb",
  data() {
    return {
      router: Navigator,
      store:BreadcrumbStore
    };
  },
  props: {
    serviceId: {
      type:String,
      default:""
    }
  },
  mounted() {
    this.store.getServices((data) => {
      },(err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
  },
  watch: {
    serviceId(newVal,oldVal) {
      this.store.state.serviceSlug = newVal
    },
    'store.state.serviceSlug': {
      handler(newVal) {
        if(newVal == this.serviceId) {
          return
        }
        this.router.goFeed(this,newVal)
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #007bff;
}

.navbar {
  background: #f2f2f2 !important;
}

.navbar,
a {
  color: white !important;
}

.pointer {
  cursor: pointer;
}

.navbar {
  background-color: #f2f2f2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/Breadcrumb.vue